import { mapGetters, mapActions } from "vuex"
import globalMixin from "./global";
import strings from "../strings";
const jwt = require("jsonwebtoken");

const oneMinute = 60000

const vuexMixin = {
  mixins: [globalMixin],
  data() {
    return {
      intervalUpdateCall: false,
    }
  },
  computed: {
    ...mapGetters({
      user: "site/getUser",
      me: "site/getUser",
      title: "site/getLayoutTitle",
      getBreadcrumbs: "site/getBreadcrumbs",
      layoutHomeDoubt: "site/getLayoutHomeDoubt",
      org: "organization/org",
      getItemsRandomizedStor: "site/getItemsRandomizedStor",
      getItemsOrganizedStor: "site/getItemsOrganizedStor",
      getOnFullscreen: 'site/getOnFullscreen',
      lastUpdatedDataOrg: 'organization/lastUpdatedDataOrg',
      images: 'organization/images',
      getToken: "site/getToken",
      getSelectedItemMenu: "site/getSelectedItemMenu",
      getSrcImgemApiDefault: "site/getSrcImgemApiDefault",
      phoneVx: 'organization/getPhonsContact',
      emailContactVx: 'organization/getEmailcontact',
      getTermsPoliciesTypes: 'site/getTermsPoliciesTypes',
      getTermsPoliciesData: 'site/getTermsPoliciesData',
      getTermsPoliciesAccepetd: 'site/getTermsPoliciesAccepetd',
      getNoUseCookies: 'site/getNoUseCookies',
      getIdUserWhoAccepted: 'site/getIdUserWhoAccepted',
      isSolicitation: "organization/isSolicitation",
      getCountApproval: "site/getCountApproval",
      getProfileSelected: "site/getProfileSelected",
      getMenuGroupsActive: "site/getMenuGroupsActive",
      getChartLoanding: "api/getChartLoanding",
      isApiDetailsLoading: "api/isApiDetailsLoading",
      getHeaderAdminType: "site/getHeaderAdminType",
    }),
    selectedItemMenu: {
      get() {
        return this.getSelectedItemMenu;
      },
      set(newValue) {
        this.setSelectedItemMenu(newValue)
      }
    },
    primaryVx() {
      return this.org.primaryColor ? this.org.primaryColor : ''
    },
    backGroundPrimaryVx() {
      return this.org.primaryColor && this.org.primaryColor != '' ? this.colorChild(0.80, this.org.primaryColor) : ''
    },
    bannerMainVx() {
      return this.images.bannerMain ? this.images.bannerMain : ''
    },
    bannerDoubtVx() {
      return this.images.bannerDoubt ? this.images.bannerDoubt : ''
    },
    logoMainVx() {
      return this.images.logoMain ? this.images.logoMain : ''
    },
    cnpjVx() {
      return this.org.cnpj ? this.org.cnpj : ''
    },
    billingModelVx() {
      return this.org.billingModel ? this.org.billingModel : ''
    },
    facebookUrlVx() {
      return this.org.facebook ? this.org.facebook : ''
    },
    youtubeUrlVx() {
      return this.org.youtube ? this.org.youtube : ''
    },
    linkedinUrlVx() {
      return this.org.linkedIn ? this.org.linkedIn : ''
    },
    siteVx() {
      return this.org.website ? this.org.website : ''
    },
    instagramUrlVx() {
      return this.org.instagram ? this.org.instagram : ''
    },
    logoDarkVx() {
      return this.org.idLogoDark ? this.org.idLogoDark : ''
    },
    imageLoginVx() {
      return this.org.idImageLogin ? this.org.idImageLogin : ''
    },
    logoHeaderAdminVx() {
      return this.org.idLogoHeaderAdmin ? this.org.idLogoHeaderAdmin : ''
    },
    idLogoLightVx() {
      return this.org.idLogoLight ? this.org.idLogoLight : ''
    },
    idFaviconVx() {
      return this.org.idFavicon ? this.org.idFavicon : ''
    },
    bannerVx() {
      return this.org.idBanner ? this.org.idBanner : require(`~/assets/images/bannerWhitelabelDefault.png`)
    },
    bannerTitleVx() {
      return this.org.bannerTitle ? this.org.bannerTitle : ''
    },
    bannerSubtitleVx() {
      return this.org.bannerSubtitle ? this.org.bannerSubtitle : ''
    },
    companyNameVx() {
      return this.org.companyName ? this.org.companyName : ''
    },
    tradeNameVx() {
      return this.org.tradeName ? this.org.tradeName : ''
    },
    tokenNuxt() {
      return this.user && this.user.token ? this.user.token : null
    },
    breadcrumbs: {
      get() {
        return this.getBreadcrumbs
      },
      set(newValue) {
        this.setLayoutBreadcrumbs(newValue)
      }
    },
    solicitation: {
      get() {
        return this.isSolicitation;

      },
      set(newValue) {
        this.setSolicitation(newValue)
      }
    }

  },
  beforeRouteEnter(to, from, next) {
    const routeIsAdmin = (path) => path.includes('/admin')
    const permissionName = to.name.replace('admin-', '')
    const routePermissions = strings.rolePermissions[permissionName]
    if (routeIsAdmin(to.path)) {
      next(vm => {
        const token = vm.getToken
        let route = to.path
        if (token) {
          if (routePermissions && !routePermissions.every(route => vm.haveRole(route))) {
            route = '/error'
          }
        } else {
          route = {
            path: '/login', query: {
              rt: to.path
            }
          }
        }
        vm.$router.push(route);
      })
    } else {
      next()
    }
  },
  async beforeMount() {
    const date = Date.now() / 1000
    if (!this.$vuetify.theme.themes.light.anchor || Math.round(date - this.lastUpdatedDataOrg) / (60 * 60) > 8) {
      this.solicitation = !this.solicitation
      this.$vuetify.theme.themes.light.anchor = this.primaryVx;
      this.$vuetify.theme.themes.light.primary = this.primaryVx;
      this.setLastUpdatedDataOrg(date)
      await this.callTermsPolicy()
      await this.callThemaInstitutions()
    }
  },
  destroyed() {
    if (this.intervalUpdateCall) {
      clearInterval(this.intervalUpdateCall)
    }
  },
  methods: {
    ...mapActions({
      setLayoutTitle: "site/setLayoutTitle",
      setLayoutBreadcrumbs: "site/setLayoutBreadcrumbs",
      setLayoutHomeDoubt: "site/setLayoutHomeDoubt",
      setItemsRandomizedStor: "site/setItemsRandomizedStor",
      setItemsOrganizedStor: "site/setItemsOrganizedStor",
      setOnFullscreen: "site/setOnFullscreen",
      setLastUpdatedDataOrg: "organization/setLastUpdatedDataOrg",
      setOrganization: "organization/setOrg",
      setSelectedItemMenu: "site/setSelectedItemMenu",
      setTermsPoliciesData: "site/setTermsPoliciesData",
      setTermsPoliciesAccepetd: "site/setTermsPoliciesAccepetd",
      setNoUseCookies: "site/setNoUseCookies",
      setIdUserWhoAccepted: "site/setIdUserWhoAccepted",
      setSolicitation: "organization/setSolicitation",
      setCountApproval: "site/setCountApproval",
      setProfileSelected: "site/setProfileSelected",
      setMenuGroupsActive: "site/setMenuGroupsActive",
      setRemoveMenuGroupsActive: "site/setRemoveMenuGroupsActive",
      setResetMenuGroupsActive: "site/setResetMenuGroupsActive",
      setChartLoanding: "api/setChartLoanding",
      setApiDetailsLoading: "api/setApiDetailsLoading",
      setHeaderAdminType: "site/setHeaderAdminType",
    }),
    timerFunctionFiveMintuesVX() {
      this.intervalUpdate = setInterval(() => {
        let currentdate = new Date();
        if (currentdate.getMinutes() % 15 == 0 && currentdate.getSeconds() == 0) {
          this.solicitation = !this.solicitation
        }
      }, oneMinute)
    },
    getSelectedItemByRoute() {
      let arrayPath = this.$route.path.split('/')
      if (arrayPath.length >= 4) {
        arrayPath.shift()
        let routeSrc = arrayPath.slice(0, 2)
        this.selectedItemMenu = `/${routeSrc.join('/')}`
      } else {
        this.selectedItemMenu = this.$route.path
      }
    },
    async callThemaInstitutions() {
      try {
        const result = await this.requestEds('GET', `institutions/${process.env.ID_ORGANIZATION}`)
        if (result && result.data) {
          this.setOrganization(result.data)
          this.$vuetify.theme.themes.light.anchor = this.primaryVx;
          this.$vuetify.theme.themes.light.primary = this.primaryVx;
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatDate(value, option) {
      if (value) {
        let data = new Date(value);
        return data.toLocaleDateString('pt-BR', { ...option, timeZone: 'UTC' });
      }
      return ''
    },
    async callTermsPolicy() {
      try {
        const result = await this.requestEds('GET', `terms-policies?types=%20`)
        if (result && result.data) {
          this.setTermsPoliciesData(result.data)
          const termoCookiesData = this.getTermsPoliciesData && this.getTermsPoliciesData.length > 1 ? this.getTermsPoliciesData[2].creation : 'policy'
          this.$cookiz.set(`lastVersionCookeis`, jwt.sign(termoCookiesData, process.env.COOCKIES_SECRET_KEY), {
            path: '/',
            maxAge: 60 * 60 * 24 * 7
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatDateText(value) {
      if (value != '') {
        let d = new Date(value);
        const options = {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC'
        }
        return d.toLocaleDateString('pt-BR', options);
      }
      return ''
    },
    backGroundColorVx(color) {
      return this.colorChild(0.50, color);
    },
    /***
     * Controlar intensidade de cor primary customizado mais light ou escorror ou fazer degree de mex dois cores passando os paramterods :
     * p : Porcentagem de form 0.50  igual 50% que é obrigatório
     * c0 : primeiro cor que é obrigatório
     * c1 : segundo cor é opcional para criara degree
     * l : booleano true ou false é opcional, usar em caso informar duas cores para mudar lados de degree de coro de baixo para cima ou contrario
     * */
    colorChild(p, c0, c1, l) {
      let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
      if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
      if (!this.colorChildr) this.colorChildr = (d) => {
        let n = d.length, x = {};
        if (n > 9) {
          [r, g, b, a] = d = d.split(","), n = d.length;
          if (n < 3 || n > 4) return null;
          x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
        } else {
          if (n == 8 || n == 6 || n < 4) return null;
          if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
          d = i(d.slice(1), 16);
          if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
          else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
        } return x
      };
      h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.colorChildr(c0), P = p < 0, t = c1 && c1 != "c" ? this.colorChildr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
      if (!f || !t) return null;
      if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
      else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
      a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
      if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
      else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    },
    decodeAnyToken(token) {
      const jwt = require("jsonwebtoken");
      return jwt.decode(token);
    }
  },
  head: function () {
    return {
      title: this.tradeNameVx ? this.tradeNameVx : '',
      link: [
        { rel: 'icon', type: 'image/x-icon', href: this.idFaviconVx ? this.idFaviconVx : '/tecbanIcon.png', id: 'orgFavicon' }
      ]
    }

  },

};
export default vuexMixin;
